import { AppSidebar } from "@/app/layouts/dashboard/AppSidebar";
import { useSidebar } from "@/app/layouts/dashboard/sidebar-context-core";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/shared/components/ui/sheet";

/**
 * Wrapper del sidebar para pantallas <lg. Usa el Sheet de shadcn
 * (slide-in desde la izquierda) con backdrop + animación nativa.
 *
 * El `<SheetHeader>` con `sr-only` title/description es un requerimiento
 * de accesibilidad de Radix Dialog — sin eso tira warning.
 */
export function MobileSidebar() {
  const { mobileOpen, setMobileOpen } = useSidebar();

  return (
    <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
      <SheetContent side="left" className="w-72 p-0">
        <SheetHeader className="sr-only">
          <SheetTitle>Menú de navegación</SheetTitle>
          <SheetDescription>Navega entre los módulos del backoffice</SheetDescription>
        </SheetHeader>
        <AppSidebar variant="mobile" />
      </SheetContent>
    </Sheet>
  );
}
